import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3868fa22&scoped=true"
import script from "./conversation.js?vue&type=script&lang=js&external"
export * from "./conversation.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=3868fa22&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868fa22",
  null
  
)

export default component.exports